import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArSD: CultureInfo = {
  name: 'ar-SD',
  displayName: 'العربية (السودان)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-SD',
  parent: CultureInfoAr
};
